<template>
    <b-card-body>
        <div class="table-responsive">
            <table class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th v-for="service in services">{{service}}</th>
                </tr>
                </thead>
                <tbody>
                    <template v-for="service in services">
                        <td>
                            <b-check v-model="user_services[service]"></b-check>
                        </td>
                    </template>
                </tbody>
            </table>
            <b-btn v-on:click="currentWine = wine; $refs.competitorWineSearch.open()"
                   v-b-tooltip.hover title="Ajouter" class="mt-3">
                <i class="ion ion-md-add"></i> Ajouter un vin concurrent
            </b-btn>
        </div>
    </b-card-body>
</template>
<script>
    import {
        ADMIN_GET_USERTYPES_REQUEST
    } from '../../_store/administration/user/actiontypes';
    import Breadcumb from '../../components/breadcumb';
    import { mapState } from 'vuex';

    export default {
        name: 'adminCategoryAdd',
        components: {Breadcumb,},
        mounted() {
            this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
                .then(response => {
                    this.userTypesData = response.data.usertypes
                });
        },
        computed: mapState({ errors: state => state.admin_user.errors }),
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des types d\'utilisateur', href: '/dashboard/administration/usertypelist/'},
                    { text: 'Permissions', active: true},

                ],
                userTypesData: [],
                user_services: [],
                services: [
                    'Service',
                    'Espace Documentaire',
                    'Dépot de rapport',
                    'SoftConcept',
                    'Création d\'enquête',
                    'Prestataire',
                    'Utilisateur',
                    'Reporting',
                    'Multilingue',
                    'Roadmap',
                    'attendanceMonitoring'
                ]
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addTypeUser: function (e) {
                e.preventDefault();
                this.$store.dispatch(ADMIN_ADD_USERTYPE_REQUEST, {
                    label: this.label,
                    label_en: this.label_en,
                    position: this.position
                })
                    .then(() => {
                        this.$router.push('/dashboard/administration/usertype/list');
                    })
                    .catch((error) => {

                    });
            }
        }
    };
</script>
